export default __webpack_public_path__ + "static/media/noDataFound.b749ab9e.svg";